const dashboardHome = {
  activeProjects: "Активные проекты",
  documents: "Документы",
  avgHealth: "Средн. здоровье",
  todayEvents: "События сегодня",
  recentProjects: "Последние проекты",
  viewAll: "Все",
  noProjects: "Проектов пока нет",
  noEvents: "Нет событий на сегодня",
  quickActions: "Быстрые действия",
  newProject: "Новый проект",
  newDocument: "Новый документ",
  storyMap: "vStory",
  loadError: "Ошибка загрузки данных",
  retry: "Повторить",
  entityTypes: "Сущности",
  recentEntities: "Последние сущности",
  noEntities: "Сущностей пока нет",
  items: "элементов",
  docPipeline: "Документы — конвейер",
  docDrafts: "Черновики",
  docPending: "Ожидают подписи",
  docSigned: "Подписано",
  docExpiring: "Истекают скоро",
} as const;
export default dashboardHome;
